@if (ready) {
  <div class="">
    <!-- <h1 class="h1-xs">{{validatedTool.tool.name.displayName}}
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
  </h1> -->

    <!-- warning title -->
    <!-- <div class="alert alert-warning text-center p-1 mb-0" [class.invisible]="!showWarning">
    <i class="fas fa-fw fa-exclamation-circle"></i> {{ warningText }}
  </div> -->

    <!-- parameters -->
    <div class="row">
      <div class="col">
        <!-- <h2 class="h2-xs mt-1 mb-2">Parameters</h2> -->
      </div>

      <div class="col">
        @if (isResetAllVisible()) {
          <button class="btn btn-sm btn-outline-secondary me-1 mb-2 float-end" (click)="resetAll()" title="Reset all">
            <span class="fas fa-fw fa-undo text-primary" aria-hidden="true"></span>
            Reset all
          </button>
        }
        @if (!isResetAllVisible()) {
          <button
            class="btn btn-sm btn-outline-secondary me-1 mb-2 float-end"
            (click)="resetAll()"
            title="Reset all"
            [disabled]="true">
            <span class="fas fa-fw fa-undo" aria-hidden="true"></span>
            Reset all
          </button>
        }
      </div>
    </div>

    @if (validatedTool.tool) {
      <form name="paramForm">
        @if (validatedTool.tool.parameters.length === 0) {
          <div class="font-italic text-smaller">No parameters</div>
        }

        @if (validatedTool.tool.parameters.length > 0) {
          <table class="table table-sm">
            <tbody>
              @for (parameter of validatedTool.tool.parameters; track parameter; let i = $index; let isLast = $last) {
                <tr>
                  <td style="width: 60%" [class.no-bottom-border]="isLast">
                    <!-- parameter name -->
                    {{ getDisplayName(parameter) }}
                    <!-- <span class="text-sm text-muted" *ngIf="parameter.optional">
              <i>(optional)</i>
            </span> -->

                    <!-- parameter description -->
                    <div class="text-sm text-muted">{{ parameter.description }}</div>
                  </td>

                  <!-- parameter value -->

                  <td [class.no-bottom-border]="isLast">
                    <!-- selection parameter -->
                    @if (toolService.isSelectionParameter(parameter)) {
                      <select
                        class="w-100"
                        name="parameter_{{ i }}"
                        [(ngModel)]="parameter.value"
                        (ngModelChange)="onParametersChanged()">
                        @for (option of parameter.selectionOptions; track option) {
                          <option value="{{ option.id }}">
                            {{ option.displayName || option.id }}
                          </option>
                        }
                      </select>
                    }

                    <!-- number -->
                    @if (toolService.isNumberParameter(parameter)) {
                      <input
                        class="w-100"
                        type="number"
                        [(ngModel)]="parameter.value"
                        name="parameter_{{ i }}"
                        min="{{ parameter.from }}"
                        max="{{ parameter.to }}"
                        step="{{ toolService.getStepSize(parameter) }}"
                        required="{{ !parameter.optional }}"
                        (ngModelChange)="onParametersChanged()" />
                    }

                    <!-- string -->
                    @if (toolService.isStringParameter(parameter)) {
                      <input
                        type="text"
                        class="w-100"
                        name="parameter_{{ i }}"
                        [(ngModel)]="parameter.value"
                        required="{{ !parameter.optional }}"
                        (ngModelChange)="onParametersChanged()" />
                    }

                    <!-- validation message -->
                    @if (!validatedTool.parametersValidationResults.get(parameter.name.id).valid) {
                      <div class="alert alert-warning p-1 mb-0 mt-1 text-sm">
                        {{ validatedTool.parametersValidationResults.get(parameter.name.id).message }}
                      </div>
                    }
                  </td>

                  <!-- buttons -->
                  <td [class.no-bottom-border]="isLast">
                    <!-- reset to default -->
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-dark btn-no-border float-end"
                      [class.invisible]="!isResetVisible(parameter)"
                      (click)="reset(parameter, $event)"
                      title="Reset to default">
                      <i class="fas fa-undo text-primary"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </form>
    }
  </div>
}
